import { withStyles } from "@material-ui/core";
import React from "react";
import history from "../../app/history";
import auth from "../../authentication/Auth";
import styles from "./styles";

function PaginaInicial({ classes }) {
  const handleLogin = () => {
    if (auth.isAuthenticated()) {
      history.replace("/funcionalidades");
    } else {
      history.replace("/login");
    }
  };

  setTimeout(handleLogin, 2000);

  return (
    <div className={classes.container}>
      <img
        src="../../images/logo-farmtell-views-color-4.png"
        alt="Logo FarmTell Views"
      />
    </div>
  );
}

export default withStyles(styles)(PaginaInicial);
